export { usePartnerPromo } from './usePartnerPromo';
